import { randomString } from './random-string';

/**
 * return an unique ID, based on time + 5 random chars
 */
export const randomId = () => `${new Date().getTime().toString(36)}-${randomString(5)}`;
